export function requiredBookingErrors({
  clientId,
  serviceId,
}: {
  clientId: string
  serviceId: string
}): Record<string, string> {
  const errors: Record<string, string> = {}
  if (!clientId) errors.client_id = "Selecciona un cliente"
  if (!serviceId) errors.service_id = "Selecciona un servicio"
  return errors
}
